var config = {
    apiBaseUrl: "http://localhost:35301/",
    apiEndpoints: {},
    plausibleDomain: "localhost",
    plausibleTrackingApi: "https://pl.datlab.eu"
};

if (import.meta.env.VITE_VUE_APP_SERVER == "dev_matej") {
    Object.assign(config, {
        apiBaseUrl: "http://localhost:35301/"
    });
}

if (import.meta.env.VITE_VUE_APP_SERVER == "dev01_kuba") {
    Object.assign(config, {
        apiBaseUrl: "http://localhost:22051/"
    });
}

if (import.meta.env.VITE_VUE_APP_SERVER == "test") {
    Object.assign(config, {
        apiBaseUrl: "https://redflags-test.datlab.eu/"
    });
}

if (import.meta.env.VITE_VUE_APP_SERVER == "staging") {
    Object.assign(config, {
        apiBaseUrl: "https://redflags-staging.datlab.eu/",
        plausibleDomain: "redflags-staging.datlab.eu"
    });
}

if (import.meta.env.VITE_VUE_APP_SERVER == "production") {
    Object.assign(config, {
        apiBaseUrl: "https://kontrola.datlab.eu/",
        gtmkey: "GTM-TPJKB9K",
        plausibleDomain: "kontrola.datlab.eu"
    });
}

export const CONFIG = config;
